
import { defineComponent } from 'vue';
import timer from '@/Utilities/timer';
import homeUtils from '@/Utilities/homeUtils';

export default defineComponent({
    props:{
        timeCounter:{
            type: Number,
            default: 0
        },
        label:{
            type: String,
            default: ''
        },
        couponLabel:{ // ex: MYPACK | 30% DISCOUNT
            type: String,
            default: ''
        }
    },
    data(){
        return {
            timerShow: false,
            labelWithoutClass: '',
            hours: 0,
            mins: 0,
            secs: 0
        }
    },
    mounted() {
        this.labelWithoutClass = homeUtils.removeClass(this.label);
        if(this.labelWithoutClass.includes('icon-promo-code')){
            this.labelWithoutClass = this.labelWithoutClass.replace('icon-promo-code','prz-discount');
        }
        //timer not difined (no design)
        //this.setVar();
    },
    computed:{
        hoursFormat(){
            return timer.formatNumberCounter(this.hours);
        },
        minsFormat(){
            return timer.formatNumberCounter(this.mins);
        },
        secsFormat(){
            return timer.formatNumberCounter(this.secs);
        },
    },
    methods: {
        setVar() {
            let calc = timer.calcTimerCounter(this.timeCounter);
            if(!calc){
                this.timerShow = false;
                return;
            }
            this.secs = calc.secs;
            this.mins = calc.mins;
            this.hours = calc.hours;
            this.timerShow = true;
            setTimeout(() => {this.setVar();}, 1000);
        }
    }
});
